module.exports = __webpack_public_path__ + "img/droplet.44dc254b.svg";